import { useMutation } from '@fv/client-core'
import type { FullShipment } from '@fv/client-types'
import type { BookRateDTO } from '@fv/models'

import { useUpdateCachedLoad } from '@/hooks/shipments'
import { shipperFetch } from '@/utils/shipperFetch'

type BookRateRequestOpts = BookRateDTO & {
  loadId: string
  quoteId: string
}
const postLoadBook = async ({
  loadId,
  quoteId,
  ...body
}: BookRateRequestOpts) =>
  await shipperFetch<FullShipment>(
    `/shipments/${loadId}/quotes/${quoteId}/book`,
    {
      method: 'POST',
      body,
    },
  )
export const useBookRate = () => {
  return useMutation(postLoadBook)
}

export const useVendorBookRate = () => {
  const updateCachedLoad = useUpdateCachedLoad()
  return useMutation(postLoadBook, {
    onSettled: async updatedLoad => {
      updateCachedLoad({
        updatedLoad,
      })
    },
  })
}
